import React from 'react';
import Badge from 'react-bootstrap/Badge';
export const AcFormFieldBadge = ({ size = 'md', type = 'required' }) => {
    const badgeTypes = {
        required: {
            variant: 'attention',
            text: '必須',
        },
        optional: {
            variant: 'success',
            text: '任意',
        },
        outputFormat: {
            variant: 'secondary4',
            text: '出力形式',
        },
        editable: {
            variant: 'secondary2',
            text: '編集可',
        },
        nonEditable: {
            variant: 'secondary2',
            text: '編集不可',
        },
    };
    let badgeStyles = {
        paddingTop: '3px',
        paddingBottom: '3px',
        paddingLeft: '5px',
        paddingRight: '5px',
    };
    // if (size === 'sm') {
    //   badgeStyles.padding = '1px 4px';
    // }
    return (React.createElement(Badge, { variant: type ? badgeTypes[type].variant : undefined, className: "fs-minimum font-weight-bold", style: badgeStyles }, type && badgeTypes[type].text));
};
AcFormFieldBadge.displayName = 'AcFormFieldBadgeProps';
